import { render, staticRenderFns } from "./goodsStateRecord.vue?vue&type=template&id=60438811"
import script from "./goodsStateRecord.vue?vue&type=script&lang=js"
export * from "./goodsStateRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports